import React from 'react';
import styled from 'styled-components'
import { makeStyles } from '@material-ui/core/styles';
import Slider from '@material-ui/core/Slider';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '75%',
  },
  margin: {
    height: theme.spacing(3),
  },
}));

const QuestionsText = styled.span``

const ContentWrapper = styled.div`
    width: 100%;
    display: flex;
    justify-content: space-around;
    align-items: center
`

const QuestionQuantitySlider = ({ questions, onChange }) => {
  const classes = useStyles();

  const valuetext = (value) => {
    onChange(value)
  }

  return (
    <ContentWrapper>
        <div className={classes.root}>
            <Slider
                defaultValue={10}
                getAriaValueText={valuetext}
                aria-labelledby="discrete-slider-custom"
                step={10}
                min={10}
                marks
                valueLabelDisplay="auto"
            />
        </div>
        <QuestionsText>
            {questions}
        </QuestionsText>
    </ContentWrapper>
  );
}

export default QuestionQuantitySlider